// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.floatingLayout-module_floatingLayout__JOD8Y {
    pointer-events: none;
    position: fixed;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
    animation-duration: 500ms;
    animation-fill-mode: forwards;
    animation-name: none;
    z-index: 1002;

    @media screen and (min-width: 481px) {
        max-width: 480px;
    }
    @media screen and (min-width: 708px) {
        max-width: 100%;
    }
    @media screen and (min-width: 889px) {
        max-width: 888px;
    }
}

.floatingLayout-module_bottom__eWwOJ {
    bottom: 0;
}

.floatingLayout-module_aliment-top__jyYPb {
    top: 0;
}

.floatingLayout-module_aliment-center__gAZYg {
    top: 50%;
    transform: translateY(-50%);
}

.floatingLayout-module_aliment-bottom__Z76jN {
    bottom: 0;
}

.floatingLayout-module_fadeIn__l2WlE {
    animation-name: floatingLayout-module_fadeIn__l2WlE;
}

.floatingLayout-module_fadeInTop__d64Qu {
    animation-name: floatingLayout-module_fadeInTop__d64Qu;
}

.floatingLayout-module_fadeOut__Ph0Dw {
    animation-name: floatingLayout-module_fadeOut__Ph0Dw;
}

.floatingLayout-module_fadeOutTop__GmxBi {
    animation-name: floatingLayout-module_fadeOutTop__GmxBi;
}

@keyframes floatingLayout-module_fadeOut__Ph0Dw {
    0% {
        opacity: 1;
    }
    100% {
        transform: translateY(100px);
        opacity: 0;
        display: none;
    }
}

@keyframes floatingLayout-module_fadeOutTop__GmxBi {
    0% {
        opacity: 1;
    }
    100% {
        transform: translateY(-100px);
        opacity: 0;
        display: none;
    }
}

@keyframes floatingLayout-module_fadeIn__l2WlE {
    0% {
        opacity: 0;
        display: block;
        transform: translateY(100px);
    }
    100% {
        bottom: 0;
        opacity: 1;
    }
}

@keyframes floatingLayout-module_fadeInTop__d64Qu {
    0% {
        opacity: 0;
        display: block;
        transform: translateY(-100px);
    }
    100% {
        opacity: 1;
    }
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/layout/css/floatingLayout.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,eAAe;IACf,OAAO;IACP,QAAQ;IACR,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;IAC7B,oBAAoB;IACpB,aAAa;;IAEb;QACI,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mDAAsB;AAC1B;;AAEA;IACI,sDAAyB;AAC7B;;AAEA;IACI,oDAAuB;AAC3B;;AAEA;IACI,uDAA0B;AAC9B;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,4BAA4B;QAC5B,UAAU;QACV,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,6BAA6B;QAC7B,UAAU;QACV,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,cAAc;QACd,4BAA4B;IAChC;IACA;QACI,SAAS;QACT,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,cAAc;QACd,6BAA6B;IACjC;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":[".floatingLayout {\n    pointer-events: none;\n    position: fixed;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n    animation-duration: 500ms;\n    animation-fill-mode: forwards;\n    animation-name: none;\n    z-index: 1002;\n\n    @media screen and (min-width: 481px) {\n        max-width: 480px;\n    }\n    @media screen and (min-width: 708px) {\n        max-width: 100%;\n    }\n    @media screen and (min-width: 889px) {\n        max-width: 888px;\n    }\n}\n\n.bottom {\n    bottom: 0;\n}\n\n.aliment-top {\n    top: 0;\n}\n\n.aliment-center {\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.aliment-bottom {\n    bottom: 0;\n}\n\n.fadeIn {\n    animation-name: fadeIn;\n}\n\n.fadeInTop {\n    animation-name: fadeInTop;\n}\n\n.fadeOut {\n    animation-name: fadeOut;\n}\n\n.fadeOutTop {\n    animation-name: fadeOutTop;\n}\n\n@keyframes fadeOut {\n    0% {\n        opacity: 1;\n    }\n    100% {\n        transform: translateY(100px);\n        opacity: 0;\n        display: none;\n    }\n}\n\n@keyframes fadeOutTop {\n    0% {\n        opacity: 1;\n    }\n    100% {\n        transform: translateY(-100px);\n        opacity: 0;\n        display: none;\n    }\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0;\n        display: block;\n        transform: translateY(100px);\n    }\n    100% {\n        bottom: 0;\n        opacity: 1;\n    }\n}\n\n@keyframes fadeInTop {\n    0% {\n        opacity: 0;\n        display: block;\n        transform: translateY(-100px);\n    }\n    100% {\n        opacity: 1;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"floatingLayout": `floatingLayout-module_floatingLayout__JOD8Y`,
	"bottom": `floatingLayout-module_bottom__eWwOJ`,
	"aliment-top": `floatingLayout-module_aliment-top__jyYPb`,
	"aliment-center": `floatingLayout-module_aliment-center__gAZYg`,
	"aliment-bottom": `floatingLayout-module_aliment-bottom__Z76jN`,
	"fadeIn": `floatingLayout-module_fadeIn__l2WlE`,
	"fadeInTop": `floatingLayout-module_fadeInTop__d64Qu`,
	"fadeOut": `floatingLayout-module_fadeOut__Ph0Dw`,
	"fadeOutTop": `floatingLayout-module_fadeOutTop__GmxBi`
};
export default ___CSS_LOADER_EXPORT___;
